import PropTypes from "prop-types";
import React from "react";
import PartPreview from "../../components/PartPreview";
import { getParts } from "../../util/parts";
import "./User.css";

class User extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: props.match.params.username,
      loaded: false,
      parts: [],
    };
  }

  componentDidMount() {
    getParts(this.state.username).then(parts =>
      this.setState({ parts, loaded: true }),
    );
  }

  render() {
    const { loaded, parts, username } = this.state;
    const hasParts = !loaded || parts.length > 0;
    return (
      <div>
        <div className="partList">
          <div className="partBanner">
            <h1>{username}&#39;s Parts</h1>
          </div>
          {hasParts ? (
            parts.map(part => (
              <PartPreview
                key={part.createdAt}
                name={part.name}
                createdBy={part.createdBy}
                sequence={part.sequence}
              />
            ))
          ) : (
            <h3>{username} does not exist or does not have any parts.</h3>
          )}
        </div>
      </div>
    );
  }
}

User.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      username: PropTypes.string,
    }),
  }).isRequired,
};

export default User;



// WEBPACK FOOTER //
// ./src/pages/User/User.js